import React, { useEffect, useRef } from 'react'
import { Switch, Route, useLocation, Link } from 'react-router-dom'
import Confetti from 'react-confetti'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'
import useQuery from '@/hooks/useQuery'
import { useGlobalState } from '@/state'
import Loading from '@/shared/Loading'
import SocialIndex from '@/pages/SocialIndex'


function breadCrumbs() {
  const location = useLocation()
  const activePath = location.pathname
  const crumbs = [
    { to: '/social', name: 'Social' }
  ]
  if (activePath === '/social') {
    crumbs.push({ to: '/social', name: 'Social' })
  }
  return crumbs
}

function pageTitle() {
  const location = useLocation()
  const activePath = location.pathname
  const buttons = []

  const titleInfo = {
    title: 'Social',
    buttons: buttons
  }

  return titleInfo
}

export default function SocialContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()
  const [, setToast] = useGlobalState('toast')
  const { getRequest } = useQuery()
  const scrollRef = useRef(null)

  useEffect(() => {
    scrollRef?.current?.scrollIntoView()
  }, [])

  return <>
    <div ref={scrollRef} />
    <Breadcrumbs>
      { crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle={titleInfo.title}>
      {titleInfo.buttons}
    </PageTitle>
    <Switch>
      <Route {...props} exact path={['/social']}>
        <SocialIndex />
      </Route>
    </Switch>
  </>
}
